import type { I18nInstanceType, TranslationsType } from '@/types/i18n';

let i18nInstance: I18nInstanceType | null = null;

export function initInstance(translations: Record<string, string>, defaultTranslations: Record<string, string> = {}) {
  const hasOwnTranslation = (key: string): boolean => typeof translations[key] !== 'undefined';

  const getTranslation = <Key extends keyof TranslationsType>(key: Key): string => {
    if (hasOwnTranslation(key)) {
      return translations[key];
    }

    console.warn(`[i18n]: Missing translation for the key "${key}". Please check passed "translations" options.`);

    if (defaultTranslations?.[key]) {
      return defaultTranslations[key];
    }

    return key;
  };

  const replaceTranslationParams = (translation: string, params?: Record<string, string>): string => {
    if (typeof params === 'undefined') {
      return translation;
    }

    return translation.replace(/{{(\w+)}}/g, (placeholder: string, key: string) => params[key] || placeholder);
  };

  i18nInstance = (() => {
    const translate = <Key extends keyof TranslationsType>(key: Key, params?: Record<string, string>): string => {
      const translation = getTranslation(key);

      return replaceTranslationParams(translation, params);
    };

    return {
      getTranslation,
      translate,
    };
  })();

  return i18nInstance;
}

export function getI18nInstance(): I18nInstanceType {
  if (i18nInstance === null) {
    throw new Error(
      '[i18n]: The module did not initialized. There is no current i18n instance. Use "initInstance" to create one.'
    );
  }

  return i18nInstance;
}
